import React, { useEffect, useState } from 'react'
import logo from './assets/logo.png'
import hamburger from './assets/hamburger.svg'
import { useNavigate } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'
import { linkValue } from '../../features/nav/linkSlice'
import closeIcon from './assets/close.svg'
// import { IoMdClose } from "react-icons/io";


const Nav = () => {
  const navigate = useNavigate()
  const dispatch = useDispatch()
  const [isOpen, setIsOpen] = useState(false);
  // const [isClosing, setIsClosing] = useState(false);

  const link = useSelector((state) => state.link.value.payload)

  const hideModal = (event) => {
    const modal = document.getElementById('modal');
    // Check if the clicked element is outside of the modal
    if (event.target !== modal && !modal.contains(event.target)) {
      // setIsClosing(true);
      // setTimeout(() => {
      //   setIsOpen(false); // Call the function to close the modal
      // }, 300); // Duration of the zoom-out animation
      setIsOpen(false);
    }
  }

  const changePage = (pageNumber) => {
    dispatch(linkValue(pageNumber))
    if (pageNumber === 0) {
      window.location.href = "/"; // This forces a reload and navigates to "/"

    }
    else if (pageNumber === 1) {
      navigate("/login")
    }
    else if (pageNumber === 2) {
      navigate("/signup")
    }
    else if (pageNumber === 4) {
      navigate("/about")
    }
    else {
      navigate("/blog")
    }
  }
  useEffect(() => {
    const url = window.location.pathname
    if (url === "/login") {
      dispatch(linkValue(1))
    }
    else if (url === "/signup") {
      dispatch(linkValue(2))
    }
    else if (url === "/blog") {
      dispatch(linkValue(3))
    }
    else if (url === "/about") {
      dispatch(linkValue(4))
    }
    else {
      dispatch(linkValue(0))
    }
  }, [dispatch])

  useEffect(() => {

    const scrollToTop = () => {
      window.scrollTo({
        top: 0,
        behavior: 'smooth', // Smooth scrolling behavior
      });
    };

    scrollToTop()

  }, [])
  return (
    <div className='w-full'>
      <div className=' bg-white w-full h-[96px] md:-[117px] lg:h-[12vh] mg:h-[14vh] fixed flex items-center justify-between px-6 md:px-8 mg:px-[64px]  z-[100]'>
        <img onClick={() => changePage(0)} src={logo} alt="logo" className=' bg-white cursor-pointer w-[164px] h-[32px] md:w-[174px] md:h-[34px] lg:w-[266px] lg:h-[52px]' />
        <div className=' hidden  md:flex gap-[27px] text-[16px] font-black leading-[21.6px] lg:text-[18px] lg:leading-[24.6px] '>
          <button onClick={() => changePage(1)} className={` ${link === 1 ? `text-ravblue cursor-not-allowed` : ``}  `}>Login</button>
          <button onClick={() => changePage(2)} className={` ${link === 2 ? "text-ravblue cursor-not-allowed" : ""}  `}>Sign up</button>
          <button onClick={() => changePage(4)} className={` ${link === 4 ? " text-ravblue cursor-not-allowed" : ""} `}>About us</button>

          <button onClick={() => changePage(3)} className={` ${link === 3 ? "text-ravblue cursor-not-allowed" : ""} `}>Blog</button>

          {link === 0 && (
            <div>
              <button onClick={() => navigate("/signup")} className="bg-ravblue text-white text-[16px] font-bold h-[44px] px-[24px] rounded-[80px] flex items-center justify-center">Join as a vendor</button>
            </div>
          )}
        </div>
        {/* Mobile: only show About us */}

        <div className='flex md:hidden'>
          <div className=' md:hidden  flex gap-[27px] text-[16px] font-black leading-[21.6px] lg:text-[18px] lg:leading-[24.6px] '>
            <button
              onClick={() => changePage(4)}
              className={`text-base border  px-3 py-1 rounded-[80px] ${link === 4 ? "text-ravblue cursor-not-allowed border-ravblue hidden " : " border-black "}`}
            >
              About us
            </button>
          </div>
          <img src={hamburger} alt="hamburger" onClick={() => setIsOpen(true)} className=' cursor-pointer flex md:hidden ml-4 ' />

        </div>
      </div>
      {/* Mobile Menu */}
      {isOpen && (
        <div onClick={hideModal} className={`md:hidden fixed inset-0 bg-black bg-opacity-50 z-[120] flex items-center justify-center`}>
          {/* <div onClick={hideModal} data-aos="zoom-in" data-aos-duration="3000" className={`sm:hidden fixed inset-0 bg-black bg-opacity-50 z-[120] flex items-center justify-center`}> */}

          {/* <div data-aos="fade-right" data-aos-duration="3000" data-aos-easing="ease-in-sine" id='modal' className="bg-white w-4/5 h-full max-w-[13rem] xm:max-w-[14rem] absolute left-0 transform z-50"> */}
          <div id='modal' className="bg-white w-full h-full  absolute left-0 transform z-50">
            <div className='w-full flex items-center justify-between pt-[25px] px-[24px]'>
              <img onClick={() => changePage(0)} src={logo} alt="logo" className=' bg-white cursor-pointer w-[164px] h-[34px]' />
              {/* Close Button */}
              <button
                className=" text-white"
                onClick={() => setIsOpen(false)}
              >
                <img src={closeIcon} alt='close' className='  ' />
              </button>
            </div>
            {/* Your navigation links here */}
            <div className=' px-[24px] items-start justify-start mt-[52px] text-[24px] leading-[32.4px] font-black flex flex-col gap-[18px] '>
              {link === 0 && (
                <div>
                  <button onClick={() => navigate("/signup")} className="bg-ravblue text-white text-[16px] font-bold h-[44px] px-[24px] rounded-[80px] flex items-center justify-center w-[199px}">Join as a vendor</button>
                </div>
              )}

              <button onClick={() => changePage(1)} className={` ${link === 1 ? `text-ravblue cursor-not-allowed` : `text-ravdeepblue`}  `}>Login</button>
              <button onClick={() => changePage(2)} className={` ${link === 2 ? "text-ravblue cursor-not-allowed" : "text-ravdeepblue"}  `}>Sign up</button>
              <button onClick={() => changePage(3)} className={` ${link === 3 ? "text-ravblue cursor-not-allowed" : "text-ravdeepblue"} `}>Blog</button>
            </div>
          </div>
        </div>
      )}
    </div>
  )
}

export default Nav
